<ng-template #timeoutTemplate let-c="close" let-d="dismiss">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Logout</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeTimeoutModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>You will be logged out within <b>{{timeOutTimeLeft}}</b> seconds.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-brand-main klaim_btn text-center" (click)="closeTimeoutModal()">Keep me logged in</button>
        <button type="button" class="btn-brand-main klaim_btn text-center" (click)="logOut()">Logout</button>
      </div>    
    </div>  
  </ng-template>